module.exports = __webpack_public_path__ + "img/tencent-group-qrcode.2d351424.jpg";